<template>
  <div>
    <!-- <h5>Face Recognetion</h5> -->
    <!-- <button type="button" @click="openCamera">Open Camera</button> -->
    <div id="liveView" class="videoView">
      <video
        id="webcamp"
        style="transform: scaleX(-1)"
        autoplay
        playsinline
        ref="videoRef"
      ></video>
    </div>
  </div>
</template>

<script>
import { FaceDetector, FilesetResolver } from "@mediapipe/tasks-vision";
import axios from "axios";

// import dataWasm from "@mediapipe/tasks-vision/wasm";
export default {
  data() {
    return {
      children: [],
      captureInterval: null,
      capturedImageCount: 0,
      info: "",
      file: "",
      resizedFile: null,
      resizedFile2: null,
      resizeParams: {
        maxWidth: 800,
        maxHeight: 600,
        maxSize: 5 * 1024 * 1024,
      },
      responseData: {
        status: 200,
        iserror: false,
        message: "OK!",
      },
      // dataWasm: require('@mediapipe/tasks-vision/wasm'),
      // dataModel: require("/blaze_face_short_range.tflite"),
    };
  },
  mounted() {
    let constrain = {
      video: true,
    };

    axios
      .get(
        "https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location"
      )
      .then((res) => {
        console.log(res);
        let info = JSON.stringify(res.data.cityData[0]);
        this.info = info;
      });

    if (navigator.getUserMedia) {
      navigator.mediaDevices.getUserMedia(constrain).then((stream) => {
        const videoMedia = document.getElementById("webcamp");
        videoMedia.srcObject = stream;
        this.processResults();
      });
    }
    this.openCamera();
  },
  beforeDestroy() {
    clearInterval(this.captureInterval);
  },
  methods: {
    openCamera() {
      let constrain = {
        video: true,
      };
      if (navigator.getUserMedia) {
        navigator.mediaDevices.getUserMedia(constrain).then((stream) => {
          const videoMedia = document.getElementById("webcamp");
          videoMedia.srcObject = stream;
          this.processResults();
        });
      }

      if (navigator.getUserMedia) {
        navigator.mediaDevices.getUserMedia(constrain).then((stream) => {
          const videoMedia = document.getElementById("webcamp");
          videoMedia.srcObject = stream;
          videoMedia.style.width = "100%";
          videoMedia.style.height = "40%";
          this.processResults();
        });
      }
    },

    displayVideoDetection(detections) {
      const liveView = document.getElementById("liveView");
      const videoMedia = document.getElementById("webcamp");

      for (let child of this.children) {
        liveView.removeChild(child);
        console.log(liveView);
      }
      this.children.splice(0);

      console.log(this.children);

      for (let detection of detections) {
        const p = document.createElement("p");
        p.innerText =
          "Confidence: " +
          Math.round(parseFloat(detection.categories[0].score) * 100) +
          "%";
        p.style =
          "position: absolute;" +
          "color: #fff;" +
          "border: 1px solid #fff;" +
          "left: " +
          (videoMedia.offsetWidth -
            detection.boundingBox.width -
            detection.boundingBox.originX) +
          "px;" +
          "top: " +
          (detection.boundingBox.originY - 30) +
          "px; " +
          "width: " +
          (detection.boundingBox.width - 10) +
          "px;";

        const highlighter = document.createElement("div");
        highlighter.setAttribute("class", "highlighter");
        highlighter.style =
          "position: absolute;" +
          "bacground: rgba(0, 255, 0, 0.25);" +
          "border: 1px solid #fff;" +
          "left: " +
          (videoMedia.offsetWidth -
            detection.boundingBox.width -
            detection.boundingBox.originX) +
          "px;" +
          "top: " +
          detection.boundingBox.originY +
          "px;" +
          "width: " +
          (detection.boundingBox.width - 10) +
          "px;" +
          "height: " +
          detection.boundingBox.height +
          "px;";

        liveView.appendChild(highlighter);
        liveView.appendChild(p);
        this.children.push(highlighter);
        this.children.push(p);
        for (let keypoint of detection.keypoints) {
          const keypointEl = document.createElement("span");
          keypointEl.className = "key-point";
          keypointEl.style.top = `${
            keypoint.y * videoMedia.offsetHeight - 3
          }px`;
          keypointEl.style.left = `${
            videoMedia.offsetWidth - keypoint.x * videoMedia.offsetWidth - 3
          }px`;
          liveView.appendChild(keypointEl);
          this.children.push(keypointEl);
        }
        this.captureFrame();
      }
    },

    captureFrame() {
      const videoMedia = document.getElementById("webcamp");
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = videoMedia.videoWidth;
      canvas.height = videoMedia.videoHeight;

      context.drawImage(videoMedia, 0, 0, canvas.width, canvas.height);

      const imageDataUrl = canvas.toDataURL("image/jpeg");
      this.stopCamera();
      this.convertBase64ToFile(imageDataUrl);
    },

    async convertBase64ToFile(imageDataUrl) {
      if (imageDataUrl) {
        const base64WithoutMetadata = imageDataUrl.split(",")[1];
        const blob = this.base64ToBlob(base64WithoutMetadata, "image/png");
        const imageFile = new File([blob], "image.png", { type: "image/png" });

        await this.resizeFile(imageFile, this.resizeParams);
        await this.waitForResizedFile();

        if (this.resizedFile) {
          console.log("Setelah Resized data !!! ");
          let formData = new FormData();
          formData.append("file", this.resizedFile);
          formData.append("info", this.info);
          return axios
            .post(
              "/v2/clearing/operator/offexchange/withdrawal/fr_confirmation",
              formData
            )
            .then((res) => {
              if (res.status == 200) {
                const dataResponse = JSON.stringify(res.data);
                this.$router.push({
                  path: "/detail-request-withdraw-FR-off-exchange",
                  query: { responseData: dataResponse },
                });
              }
            })
            .catch((error) => {
              this.stopCamera();
              this.$toast.error(" " + error);
              console.log("ini data" + error);
              this.$router.push("/withdrawalOff");
            });
        } else {
          console.warn("Resize operation failed or not completed.");
        }
      } else {
        console.warn("No base64 data available.");
      }
    },

    async requestFormData(fileData) {
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("info", this.info);
      return axios.post(
        "/v2/clearing/operator/offexchange/withdrawal/fr_confirmation",
        formData
      );
    },

    async waitForResizedFile() {
      while (!this.resizedFile) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    },

    resizeFile(file, params) {
      const { maxWidth, maxHeight, maxSize } = params;
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          let newWidth = image.width;
          let newHeight = image.height;

          if (image.width > maxWidth) {
            newWidth = maxWidth;
            newHeight = (maxWidth / image.width) * image.height;
          }

          if (newHeight > maxHeight) {
            newHeight = maxHeight;
            newWidth = (maxHeight / image.height) * image.width;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          context.drawImage(image, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            if (blob.size <= maxSize) {
              this.resizedFile = new File([blob], file.name, {
                type: file.type,
              });
            } else {
              // Handle the case where the resized file is still too large
              console.error("Resized file is still too large");
            }
          }, file.type);
        };

        image.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: mimeType });
    },

    stopCamera() {
      const mediaStream = document.getElementById("webcamp").srcObject;
      if (mediaStream) {
        const tracks = mediaStream.getTracks();
        tracks.forEach((track) => track.stop());
        document.getElementById("webcamp").srcObject = null;
      } else {
        console.warn("No media stream to stop");
      }
      console.log("Exiting stopCamera function");
    },

    async processResults() {
      const videoMedia = document.getElementById("webcamp");
      const vision = await FilesetResolver.forVisionTasks(
        // path/to/wasm/root
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"
      );
      let lastVideoTime = -1;
      let startTimeMs = performance.now();
      let faceDetection = await FaceDetector.createFromOptions(vision, {
        baseOptions: {
          modelAssetPath:
            window.location.origin + "/blaze_face_short_range.tflite",
          delegate: "GPU",
        },
        runningMode: "VIDEO",
      });
      if (videoMedia.currentTime !== lastVideoTime) {
        lastVideoTime = videoMedia.currentTime;
        const detections = faceDetection.detectForVideo(
          videoMedia,
          startTimeMs
        ).detections;
        this.displayVideoDetection(detections);
      }
      window.requestAnimationFrame(this.processResults);
    },
  },
};
</script>

<style scoped>
.videoView {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.videoView p {
  position: absolute;
  padding: 5px;
  background-color: #007f8b;
  color: #fff;
  border: 1px sholid rgba(255, 255, 255, 0.7);
  z-index: 2;
  font-size: 12px;
  margin: 0;
}

.highlighter {
  background: rgba(0, 255, 0, 0.25);
  border: 1px solid #fff;
  z-index: 1;
  position: absolute;
}

.key-point {
  position: absolute;
  z-index: 1;
  width: 3px;
  height: 3px;
  background-color: #ff0000;
  /* border: 1px solid #ffffff; */
  border-radius: 50%;
  display: block;
}

video {
  width: 100%;
  height: auto;
  aspect-ratio: 12 / 9; /* Sesuaikan dengan aspek rasio video Anda */
}
</style>
